import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "chevron-down",
  "use": "chevron-down-usage",
  "viewBox": "0 0 8 5",
  "content": "<symbol viewBox=\"0 0 8 5\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"chevron-down\">\n  <g transform=\"translate(-206.000000, -55.000000)\">\n    <polyline id=\"chevron-down_arrow_down\" style=\" fill-rule:evenodd;\" transform=\"translate(210.000000, 57.500000) translate(-210.000000, -57.500000) \" points=\"213.258951 55.0039214 214 55.7647061 210.038758 60 206 55.7686275 206.733639 55 210.031272 58.454902\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol